import React, { useEffect, useRef, useState } from "react";
import { SelectChoice } from "../../../helpers/types";
import OutsideAlerter from "../../../hooks/OutClickNotifier";
import { ComboboxItem, OptionsFilter, Select } from "@mantine/core";
import { FieldData } from "../../../hooks/useForm";
const CloseIcon = () => {
   return (
      <svg height='16' width='16' viewBox='0 0 20 20'>
         <path d='M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z'></path>
      </svg>
   );
};

const MultiSelect = ({
   placeHolder,
   choices,
   isMulti,
   formData,
   options,
   label,
   ...rest
}: {
   name: string;
   label?: string;
   placeHolder?: string;
   choices: SelectChoice[];
   options?: {
      required?: boolean;
      isRequired?: Function;
   };
   isMulti?: boolean;
   readOnly?: boolean;
   onChange?: Function;
   formData?: Map<string, any>;
}) => {

   function getSelectValue() {
      let v = formData?.get(rest.name);
      return `${v}`
   }

   const selectOnChange = (data: FieldData) => {
      rest.onChange && rest.onChange(data);
   };

   const optionsFilter: OptionsFilter = ({ options, search }) => {
      const splittedSearch = search.toLowerCase().trim().split(" ");
      return (options as ComboboxItem[]).filter((option) => {
         const words = option.label.toLowerCase().trim().split(" ");
         return splittedSearch.every((searchWord) =>
            words.some((word) => word.includes(searchWord)),
         );
      });
   };

   return <Select
      {...rest}
      placeholder={`Select ${label}`}
      // defaultValue={getSelectValue()}
      value={getSelectValue()}
      label={label}
      radius={"md"}
      required={options?.required || undefined}
      searchable
      data={
         choices?.map((c) => {
            return {
               ...c,
               value: `${c.value}`,
               label: c.label || "",
            };
         }) || []
      }
      onChange={(value) => {
         selectOnChange({
            name: rest.name,
            value: choices?.find(
               (c) => c.value?.toString() === value,
            )?.value,
         });
      }}
      filter={optionsFilter}
      readOnly={rest?.readOnly}
   />
};

export default MultiSelect;
